function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Text, Image, TouchableOpacity } from "react-native";
import { googleImage } from "./assets";
export default class CustomGoogleLogInButton extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: () => {
        this.props.onPress();
      },
      style: this.props.style
    }, /*#__PURE__*/React.createElement(Image, {
      style: this.props.googleButtonImageStyle,
      source: googleImage
    }), /*#__PURE__*/React.createElement(Text, {
      style: this.props.googleButtonTextStyle
    }, this.props.loginGoogleButtonText));
  }
}
_defineProperty(CustomGoogleLogInButton, "propTypes", {
  testID: PropTypes.string,
  style: PropTypes.any,
  googleButtonImageStyle: PropTypes.any,
  googleButtonTextStyle: PropTypes.any,
  loginGoogleButtonText: PropTypes.string,
  onPress: PropTypes.func.isRequired
  // Customizable Area Start
  // Customizable Area End
});